import React from 'react';
import { Field } from 'redux-form/immutable';
import Error from './_Error';
import PropTypes from 'prop-types';

const FormField = ({ value, label, name, errors, component = 'input', className = '', inputClassName = '', ...props }) => (
  <div className={ `rep-edit__group ${className}` }>
    <div className='rep-edit__label'>
      <label htmlFor='name'>{label}:</label>
    </div>
    <div className='rep-edit__field'>
      <Field className={ `form__field form__field--rounded ${inputClassName}` }
        component={ component }
        name={ name }
        type='text'
        value={ value }
        { ...props } />
      <Error>{ errors}</Error>
    </div>
  </div>
);

FormField.propTypes = {
  component:    PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  errors:           PropTypes.string,
  inputClassName:   PropTypes.string,
  label:            PropTypes.string.isRequired,
  name:             PropTypes.string.isRequired,
  value:            PropTypes.string
};

export default FormField;



// WEBPACK FOOTER //
// ./app/components/shared/form/_Field.jsx